export const solutionItems = [
   'cloud',
   'server'
] as const;
